<template>
  <div class="grid grid-cols-1 max-w-max">
    <select
      v-model="model"
      class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 px-8 text-base text-slate-900 sm:text-sm sm:leading-6 outline-1 -outline-offset-1 outline-slate-300"
    >
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>
    <FunnelIcon class="pointer-events-none col-start-1 row-start-1 ml-2 size-5 self-center justify-self-start text-slate-400 sm:size-4" aria-hidden="true" />
    <ChevronDownIcon class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-slate-400 sm:size-4" aria-hidden="true" />
  </div>
</template>

<script setup>
import { ChevronDownIcon } from '@heroicons/vue/16/solid';
import { FunnelIcon } from '@heroicons/vue/24/outline';


const props = defineProps({
  options: {
    type: Array,
    default: () => []
  }
});

const model = defineModel();
</script>
